<span *ngFor="let pill of visiblePills" class="headline-category-pill">{{ short ? pill.shortLabel : pill.label }}</span>
